import React, { useState, useRef } from 'react';
import { Editor } from "primereact/editor";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { addNovedad } from "./Integracion";
import './AgregarNovedades.scss';

const AgregarNovedades = () => {
    const [novedades, setNovedades] = useState('');
    const toast = useRef(null);

    const handleSave = () => {

        if (!novedades.trim()) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'El contenido de la novedad no puede estar vacío',
                life: 3000
            });
            return;
        }

        const origin = window.location.hostname;
        const dataToSend = {origin, html: novedades };

        addNovedad(dataToSend).then(() => {
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Novedad guardada correctamente',
                life: 3000
            });
            setNovedades('');
        });

    };

    const handleCancel = () => {
        setNovedades('');
    };

    const headerTemplate = (
        <div className="novedades__header">
            <h2>Agregar Novedad</h2>
        </div>
    );

    const footerTemplate = (
        <div className="novedades__footer">
            <Button
                label="Cancelar"
                icon="pi pi-times"
                className="p-button-text p-button-danger"
                onClick={handleCancel}
            />
            <Button
                label="Guardar"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={handleSave}
            />
        </div>
    );

    return (
        <div className="novedades-container">
            <Toast ref={toast} />
            <Card header={headerTemplate} footer={footerTemplate} className="novedades__card">
                <div className="novedades__editor-container">
                    <label>Contenido</label>
                    <Editor
                        value={novedades}
                        onTextChange={(e) => setNovedades(e.htmlValue)}
                        className="novedades__editor"
                        style={{ height: '320px' }}
                    />
                </div>
            </Card>
        </div>
    );
};

export default AgregarNovedades;